//@flow
import React from 'react';
import type { Attachment } from '../../models/group_chats/Attachment';
import { downloadResource } from '../../models/Downloader';

type Props = {
  item: Attachment,
};

export default function AttachmentItem({ item }: Props) {
  return (
    <div className="ml-0 pt-15 pb-15 item">
      <div className="float-left item__name">{item.attachmentName}</div>
      <div className="float-right">
        <a
          href="#"
          onClick={() =>
            downloadResource(item.attachmentUrl, item.attachmentName)
          }
        >
          ダウンロード
        </a>
      </div>
    </div>
  );
}
